import { FC, Fragment, ReactNode, useEffect, useState } from "react";
import authSideImage1 from "../../../assets/images/others/auth-images/authSideImage1.jpg";
import authSideImage2 from "../../../assets/images/others/auth-images/authSideImage2.jpg";
import authSideImage3 from "../../../assets/images/others/auth-images/authSideImage3.jpg";
import authSideImage4 from "../../../assets/images/others/auth-images/authSideImage4.jpg";

interface Props {
  children: ReactNode;
}

const AuthLayout: FC<Props> = ({ children }) => {
  const [imageIndex, setImageIndex] = useState(0);
  const images = [authSideImage1, authSideImage2, authSideImage3, authSideImage4];

  useEffect(() => {
    const interval = setInterval(() => {
      setImageIndex((prevIndex) => (prevIndex + 1) % images.length);
    }, 6000); // Change image every 6 seconds (3 seconds for fade in and stay, 3 seconds for fade out)

    return () => clearInterval(interval);
  }, []);

  return (
    <Fragment>
      <div className="flex lg:h-screen w-full">
        <div className="w-0 lg:w-1/2 h-full relative overflow-hidden">
          {images.map((image, index) => (
            <img
              key={index}
              className={`h-screen min-w-full object-cover absolute transition-opacity duration-3000 ease-in-out ${imageIndex === index ? "fadeIn" : "fadeOut"}`}
              src={image}
              alt={`authSideImage${index + 1}`}
            />
          ))}
        </div>
        <div className="w-full lg:w-1/2">{children}</div>
      </div>
    </Fragment>
  );
};

export default AuthLayout;
